module.exports = __webpack_public_path__ + "media/images/other-payment-cd5f766d3c7892be9a8e9d29cc90cc42.svg";